import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BacnetAreaTileComponent } from '@app/administration/integrations/areas/bacnet-area-tile/bacnet-area-tile.component';
import { GatewayService } from '@services/gateway.service';
import { BacnetAreaService } from '@services/bacnet-area.service';
import { BacnetArea } from '@app/shared/models/bacnet-area.interface';
import { Gateway } from '@app/api/building/gateway/Gateway';
import { NotificationBlockComponent, StatusClass } from '@components/notification-block/notification-block.component';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '@services/user/user.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-integrations-areas',
  imports: [CommonModule, BacnetAreaTileComponent, NotificationBlockComponent],
  templateUrl: './areas.component.html',
  styleUrl: './areas.component.scss'
})
export class AreasComponent implements OnInit {
  isBusy = true;
  isGatewaysLoaded = false;
  areas: BacnetArea[];
  newArea: BacnetArea;
  gateways: Gateway[];
  buildingId: number;
  floorId: number;
  StatusClass = StatusClass;

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private bacnetAreaService: BacnetAreaService,
    private gatewayService: GatewayService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.route.params
      .pipe(
        map((params) => {
          this.floorId = params.floorId;
          this.buildingId = params.buildingId;
          this.loadAreas();
          this.loadGateways();
          return this.userService.getBuilding(params.buildingId);
        })
      )
      .subscribe();
  }

  public loadAreas(): void {
    this.areas = null;
    this.changeDetectorRef.markForCheck();
    this.bacnetAreaService.getAreas(this.buildingId).subscribe({
      next: (areas) => {
        this.areas = areas;
        this.changeDetectorRef.markForCheck();
      }
    });
  }

  public loadGateways(): void {
    this.gatewayService.getGateways(this.buildingId).subscribe({
      next: (response) => {
        this.gateways = response.gateway;
        this.isGatewaysLoaded = true;
        this.changeDetectorRef.markForCheck();
      }
    });
  }
}
